var path = 'src/app/forms/fields/diagnosis-field.html';
var html = "<div diagnosis-selector frm-model frm-required patient=patient ng-model=model ng-required=required()></div> ";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


/*****************
 ** WEBPACK FOOTER
 ** ./src/app/forms/fields/diagnosis-field.html
 ** module id = 265
 ** module chunks = 0
 **/